var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(-6.4 17.6) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12773",
    "data-name": "Path 12773",
    d: "M10.506,6.72a1.182,1.182,0,0,1,1.616,0l5.143,4.909a1.056,1.056,0,0,1,0,1.543l-5.143,4.909a1.181,1.181,0,0,1-1.616,0,1.056,1.056,0,0,1,0-1.543L13.6,13.492H2.743a1.092,1.092,0,1,1,0-2.182H13.6L10.506,8.263A1.056,1.056,0,0,1,10.506,6.72Z",
    transform: "translate(0 0)",
    fill: "#c2c2c2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArr);
export default __webpack_public_path__ + "static/media/upArr.ea51e7b9f58f8d0141148ab82923b631.svg";
export { ForwardRef as ReactComponent };